import React, { useRef, useState, useEffect } from 'react';
import { useParams } from "react-router";
import { Skeleton, Grid, Menu, Image } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { setLoading as setLoadingSpecialist_info } from "../../redux/specialist_info/reducer";
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { UPLOADS } from '../../params';
import { getSpecialistInfoList } from '../../API/specialist_info';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import { Error403_Component } from "../errors/403";
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
SwiperCore.use([Autoplay, Navigation, Pagination]);

import edjsParser from 'editorjs-parser';
const parser = new edjsParser();
import parse from 'html-react-parser';
const { useBreakpoint } = Grid;

export const SpecialistInfo = props => {
    
    const screens = useBreakpoint();
    const dispatch = useDispatch();
    const app_global = useSelector(state => state.app_global);
    const profile = useSelector(state => state.profile);
    const specialist_info = useSelector(state => state.specialist_info);
    
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const [activeItemMenu, setActiveItemMenu] = useState('business-card');

    const params = useParams();

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    useEffect(async () => {
        component_start()
    }, [profile.token]);

    async function component_start() {
        await getSpecialistInfoList({},dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [getSpecialistInfoList]`, `color: #A366FF`, json );
            if (json?.code) {
                //Done
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    var obj = {
        get groups () {
            return [];
        },
        get group () {
            if ( specialist_info.specialist_info_list.length > 0 ) {
                return specialist_info.specialist_info_list.filter( function( item ) {
                    return(
                        activeItemMenu !== "" ?
                            item['category'].toLowerCase() === activeItemMenu
                        :
                            true
                    );
                } );
            } else {
                return specialist_info.specialist_info_list;
            }
        },
    };

    function getItem(label, key, icon, children, type) {
        return {
            key,
            icon,
            children,
            label,
            type,
        };
    }
    const items = [
        getItem('Полиграфия', 'polygraphy', null, [
            getItem('Визитка', 'business-card'),
            getItem('Листовка/флаер', 'leaflet'),
            getItem('Буклет', 'booklet'),
            getItem('Прайс-лист', 'price-list'),
            getItem('Конверт', 'envelope'),
            getItem('Баннер', 'banner'),
            getItem('Холдер', 'holder'),
        ]),
        getItem('Соц. сети', 'social-networks'),
        getItem('Презентация', 'presentation'),
        getItem('Дизайн сайта', 'website-design'),
        getItem('Контент план', 'content-plan'),
        getItem('Идентификация бренда', 'brand-identification'),
        getItem('Личный кабинет', 'personal-account'),
    ];

    async function changeCategory(data) {
        await dispatch(setLoadingSpecialist_info(true));
        await setActiveItemMenu(data.key);
        await dispatch(setLoadingSpecialist_info(false));
    }

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                !profile.loading ?
                    ["3","4","5"].indexOf( profile?.data?.type ) !== -1 ?
                        <section className='container_full --specialist-info'>
                            <section className='top'>
                                <section className='container shadow default_padding'>
                                    <h1>Информация для специалистов</h1>
                                </section>
                            </section>
                            <section className='body'>
                                <section className='container shadow default_padding'>
                                    <section className='left'>
                                        <p className='title'>Категории</p>
                                        <p className='excerpt'>Вы можете выбрать интересующую вас категорию</p>
                                        <Menu
                                            defaultSelectedKeys={[activeItemMenu]}
                                            defaultOpenKeys={['polygraphy']}
                                            mode="inline"
                                            items={items}
                                            className='list-menu'
                                            onClick={changeCategory}
                                        />
                                    </section>
                                    <section className='right'>
                                        <div className='content'>
                                            <div className='header'>
                                                
                                            </div>

                                            <div className='body'>
                                                {specialist_info.loading ? 
                                                    <Skeleton active />
                                                    :
                                                    <div className='items'>
                                                        <Image.PreviewGroup>
                                                            {obj.group.map((item, index) => 
                                                                <div className='item_block'>
                                                                    {
                                                                        item.link ?
                                                                        <a className='item' href={item.link} target='_blank'>
                                                                            <img src={item.photo_big_preview} />
                                                                        </a>
                                                                    :
                                                                        <Image 
                                                                            className='item'
                                                                            preview={{
                                                                                src: item.photo_big
                                                                            }}
                                                                            src={item.photo_big_preview}
                                                                            fallback="data:image/png;base64,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"
                                                                        />
                                                                    }
                                                                </div>
                                                            )}
                                                        </Image.PreviewGroup>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </section>
                                </section>
                            </section>
                        </section>
                    :
                    <Error403_Component />
                :
                    <section className='container shadow default_padding marginTop'>
                        <div className='content'>
                            <Skeleton active />
                        </div>
                    </section>
            }
        </>
    );
};